import { render, staticRenderFns } from "./userStateLabel.vue?vue&type=template&id=6bb28270&functional=true"
import script from "./userStateLabel.vue?vue&type=script&lang=js"
export * from "./userStateLabel.vue?vue&type=script&lang=js"
import style0 from "./userStateLabel.vue?vue&type=style&index=0&id=6bb28270&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports